// @flow

const dom = ((): any => {
    const prefix = (el: any, property: string, value: string) => {
        const prefixes = ["-webkit-", "-moz-", "-ms-", "-o-", ""];
        prefixes.forEach((prefix: string) => {
            el.style[prefix + property] = value;
        });
    };

    const onTransitionEnd = (el: any, callback: any) => {
        const crossBrowserEvents = [
            "webkitTransitionEnd",
            "transitionend",
            "oTransitionEnd",
            "MSTransitionEnd",
        ];
        crossBrowserEvents.forEach((transitionEndEvent: string) => {
            el.addEventListener(transitionEndEvent, callback, { once: true });
        });
    };

    const onTransitionEndAlways = (el: any, callback: any) => {
        const crossBrowserEvents = [
            "webkitTransitionEnd",
            "transitionend",
            "oTransitionEnd",
            "MSTransitionEnd",
        ];
        crossBrowserEvents.forEach((transitionEndEvent: string) => {
            el.addEventListener(transitionEndEvent, callback);
        });
    };

    const onAnimationEnd = (el: any, callback: any) => {
        const crossBrowserEvents = [
            "animationend",
            "webkitAnimationEnd",
            "oAnimationEnd",
            "oanimationend",
            "MSAnimationEnd",
        ];
        crossBrowserEvents.forEach((transitionEndEvent: string) => {
            el.addEventListener(transitionEndEvent, callback, { once: true });
        });
    };

    const onAnimationEndAlways = (el: any, callback: any) => {
        const crossBrowserEvents = [
            "animationend",
            "webkitAnimationEnd",
            "oAnimationEnd",
            "oanimationend",
            "MSAnimationEnd",
        ];
        crossBrowserEvents.forEach((transitionEndEvent: string) => {
            el.addEventListener(transitionEndEvent, callback);
        });
    };

    return {
        prefix,
        onTransitionEnd,
        onTransitionEndAlways,
        onAnimationEnd,
        onAnimationEndAlways,
    };
})();

export default dom;
